import { ValidatorFn, AbstractControl, Validators, ValidationErrors } from '@angular/forms';

/**
 * @description  Validates if a control value exceeds a maximum length
 * @param length length
 * @returns returns
 */
export const maxLenghtValidator: (length: number) => ValidatorFn = (length: number): ValidatorFn => {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
        const result = control && control.value && control.value.length > length;
        const errors: ValidationErrors = control.errors;
        let errorsA: any = null;
        let errorE = false;
        if (errors !== null) {
          delete errors.maxLengthValidator;
          errorE = Object.keys(errors).length === 0;
        }
        if (errorE === true)  {errorsA = null;
        } else { errorsA = errors; }
        let resultado: any = errorsA;
        if (result) { resultado = { maxLengthValidator: true }; }
        return resultado;
    };
};
